import { Card } from "@pej/kore/components";

interface DesktopOnlyProps {
    /** Optional — shown as a small contextual label if loaded. */
    workspaceName?: string;
}

/**
 * Block screen shown for viewports below 1024px wide. This app is formally
 * scoped as desktop-only (see the plan's Global Constraints: "supported
 * viewports >=1024px; below that render a 'desktop only' screen"). No
 * sign-out affordance here — this app has no accounts/identity service to
 * sign out of.
 */
export function DesktopOnly({ workspaceName }: DesktopOnlyProps) {
    return (
        <div className="flex h-screen items-center justify-center p-6">
            <Card className="max-w-md p-8 text-center">
                <h1 className="text-xl font-semibold">Surveys Admin requires a desktop display</h1>
                <p className="mt-3 text-sm text-muted-foreground">
                    Please use a screen at least 1024&nbsp;px wide. We've kept the experience focused on workflows that
                    don't translate well to smaller screens.
                </p>
                {workspaceName ? (
                    <p className="mt-4 text-xs text-muted-foreground">
                        Workspace: <span className="font-medium">{workspaceName}</span>
                    </p>
                ) : null}
            </Card>
        </div>
    );
}
